/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCallDealerCta_item = {
    readonly serviceId: string | null;
    readonly seller: {
        readonly id: string;
        readonly serviceId: string | null;
        readonly favoritesByUser?: ReadonlyArray<{
            readonly serviceId: string | null;
        } | null> | null;
        readonly trackedPhone: {
            readonly phoneNumber: string | null;
        } | null;
    } | null;
    readonly " $refType": "PdpSharedCallDealerCta_item";
};
export type PdpSharedCallDealerCta_item$data = PdpSharedCallDealerCta_item;
export type PdpSharedCallDealerCta_item$key = {
    readonly " $data"?: PdpSharedCallDealerCta_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedCallDealerCta_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpSharedCallDealerCta_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "trackedPhone",
          "storageKey": null,
          "args": null,
          "concreteType": "Phone",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "phoneNumber",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "fetchUser",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "favoritesByUser",
              "storageKey": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "userIds",
                  "variableName": "userId"
                }
              ],
              "concreteType": "Favorite",
              "plural": true,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'c156f13afd9eede699f3979b15d3ea7e';
export default node;
